import { CONTACT_EMAIL, SERVICE_NAME } from '@shared/constants/service'
import { AppHeader } from '@shared/ui/app-header'
import { Footer } from '@shared/ui/footer'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/terms')({
  component: TermsPage,
})

function TermsPage() {
  return (
    <div className="flex flex-1 flex-col">
      <AppHeader leading={<AppHeader.Back />} title="이용약관" variant="blur" divider="elevation" />

      {/* Content */}
      <div className="flex-1 overflow-y-auto px-page-x py-6 pb-content-bottom">
        <div className="mx-auto max-w-lg space-y-8">
          <Section title="제1조 (목적)">
            <p>
              이 약관은 {SERVICE_NAME}(이하 &quot;서비스&quot;)가 제공하는 AI 기반 사주 분석
              서비스의 이용과 관련하여 서비스와 이용자 간의 권리, 의무 및 책임사항을 규정함을
              목적으로 합니다.
            </p>
          </Section>

          <Section title="제2조 (서비스 내용)">
            <ol className="list-decimal space-y-2 pl-5">
              <li>
                서비스는 이용자가 입력한 생년월일, 태어난 시간, 성별 등의 정보를 기반으로 인공지능(AI)
                기술을 활용하여 사주 명리학적 분석 결과를 생성·제공합니다.
              </li>
              <li>
                서비스의 분석 결과는 AI가 전통 사주 명리학을 참고하여 생성한 콘텐츠이며, AI의 특성상
                동일한 입력에 대해 다른 결과가 나올 수 있습니다. 이는 전문적인 상담이나 의학적, 법적,
                재정적 조언을 대체하지 않습니다.
              </li>
              <li>
                서비스는 무료 기본 분석과 유료 상세 분석으로 구분되며, 유료 서비스의 가격은 서비스
                내에 별도로 고지합니다.
              </li>
            </ol>
          </Section>

          <Section title="제3조 (이용 조건)">
            <ol className="list-decimal space-y-2 pl-5">
              <li>서비스는 만 14세 이상의 이용자만 이용할 수 있습니다.</li>
              <li>
                이용자는 서비스 이용 시 정확한 정보를 입력해야 하며, 허위 정보 입력으로 인한
                불이익에 대해 서비스는 책임지지 않습니다.
              </li>
              <li>
                이용자는 서비스를 개인적인 목적으로만 이용할 수 있으며, 영리 목적의 무단 복제 및
                재배포를 금지합니다.
              </li>
            </ol>
          </Section>

          <Section title="제4조 (회원가입 및 탈퇴)">
            <ol className="list-decimal space-y-2 pl-5">
              <li>
                이용자는 회원가입 없이 무료 서비스를 이용할 수 있으며, 회원가입 시 추가 기능(분석
                내역 관리 등)을 이용할 수 있습니다.
              </li>
              <li>
                회원은 언제든지 서비스 내에서 탈퇴를 요청할 수 있으며, 탈퇴 시 개인정보는
                개인정보처리방침에 따라 처리됩니다.
              </li>
              <li>
                탈퇴 후에도 법령에 따라 보존이 필요한 정보(결제 기록 등)는 해당 기간 동안
                보관됩니다.
              </li>
            </ol>
          </Section>

          <Section title="제5조 (결제 및 환불)">
            <ol className="list-decimal space-y-2 pl-5">
              <li>
                유료 서비스의 결제는 서비스 내에서 제공하는 결제 수단을 통해 이루어집니다.
              </li>
              <li>
                이용자는 결제일로부터 7일 이내에 청약철회(환불)를 요청할 수 있습니다. 다만,
                전자상거래 등에서의 소비자보호에 관한 법률 제17조 제2항에 따라 다음의 경우 청약철회가
                제한됩니다.
                <ul className="mt-2 list-disc space-y-1 pl-5">
                  <li>
                    이용자에게 책임 있는 사유로 콘텐츠가 멸실·훼손된 경우
                  </li>
                  <li>
                    디지털 콘텐츠의 제공이 개시된 경우 (분석 결과가 생성·열람된 경우). 단, 서비스는
                    결제 시 이에 대한 사전 동의를 받으며, 동의 없이 제공이 개시된 경우 환불합니다.
                  </li>
                </ul>
              </li>
              <li>
                서비스 장애로 인해 결과가 정상적으로 제공되지 않은 경우 전액 환불합니다.
              </li>
              <li>
                환불 요청은 서비스 내 고객센터 또는 이메일({CONTACT_EMAIL})을 통해 접수할 수
                있으며, 접수일로부터 3영업일 이내에 처리합니다.
              </li>
            </ol>
          </Section>

          <Section title="제6조 (AI 생성 콘텐츠에 대한 고지)">
            <ol className="list-decimal space-y-2 pl-5">
              <li>
                서비스가 제공하는 모든 사주 분석 결과는 인공지능(AI)이 생성한 콘텐츠입니다.
              </li>
              <li>
                AI 생성 결과는 통계적 모델에 기반하며, 정확성이나 완전성을 보장하지 않습니다.
                이용자는 분석 결과를 참고 자료로만 활용해야 합니다.
              </li>
              <li>
                서비스는 AI 기술의 개선에 따라 분석 방식과 결과의 품질이 변경될 수 있으며, 이에
                대해 별도의 사전 고지 없이 적용될 수 있습니다.
              </li>
            </ol>
          </Section>

          <Section title="제7조 (면책 조항)">
            <ol className="list-decimal space-y-2 pl-5">
              <li>
                서비스가 제공하는 사주 분석 결과는 오락 및 참고 목적의 AI 생성 콘텐츠이며, 이를
                근거로 한 의사결정에 대해 서비스는 법적 책임을 지지 않습니다.
              </li>
              <li>
                천재지변, 시스템 장애, 네트워크 문제 등 불가항력적 사유로 인한 서비스 중단에 대해
                책임지지 않습니다.
              </li>
              <li>
                이용자가 서비스를 통해 얻은 정보를 활용하여 발생한 손해에 대해 서비스는 책임지지
                않습니다.
              </li>
            </ol>
          </Section>

          <Section title="제8조 (서비스 중단 및 종료)">
            <ol className="list-decimal space-y-2 pl-5">
              <li>
                서비스는 시스템 점검, 장비 교체 등의 사유로 서비스를 일시적으로 중단할 수 있으며,
                사전에 공지합니다. 다만, 긴급한 경우 사후 공지할 수 있습니다.
              </li>
              <li>
                서비스를 종료하는 경우 종료일 30일 전까지 서비스 내 공지하며, 미사용 유료 서비스에
                대해서는 환불 조치합니다.
              </li>
            </ol>
          </Section>

          <Section title="제9조 (저작권 및 지식재산권)">
            <ol className="list-decimal space-y-2 pl-5">
              <li>
                서비스에서 제공하는 모든 콘텐츠(텍스트, 이미지, UI 디자인 등)의 저작권은 서비스에
                귀속됩니다.
              </li>
              <li>
                이용자는 개인적인 사주 결과를 SNS 등에 공유할 수 있으나, 서비스의 브랜드, 캐릭터, UI
                등을 무단으로 사용할 수 없습니다.
              </li>
            </ol>
          </Section>

          <Section title="제10조 (분쟁 해결)">
            <ol className="list-decimal space-y-2 pl-5">
              <li>
                서비스 이용과 관련하여 분쟁이 발생한 경우, 서비스와 이용자는 원만한 해결을 위해
                성실히 협의합니다.
              </li>
              <li>
                협의가 이루어지지 않는 경우, 관련 법령에 따라 관할 법원에 소를 제기할 수 있습니다.
              </li>
              <li>이 약관에 명시되지 않은 사항은 대한민국 법령에 따릅니다.</li>
            </ol>
          </Section>

          <Section title="제11조 (약관의 변경)">
            <p>
              서비스는 관련 법령에 위배되지 않는 범위 내에서 약관을 변경할 수 있으며, 변경 시 적용일
              7일 전부터 서비스 내 공지합니다. 이용자에게 불리한 변경의 경우 30일 전부터 공지하며,
              변경된 약관에 동의하지 않는 이용자는 서비스 이용을 중단할 수 있습니다.
            </p>
          </Section>

          <footer className="border-t border-white/[0.06] pt-6 typo-footnote text-muted-foreground">
            <p>시행일: 2026년 3월 31일</p>
            <p className="mt-1">{SERVICE_NAME} 운영팀</p>
          </footer>
        </div>
      </div>

      <Footer />
    </div>
  )
}

function Section({
  title,
  children,
}: {
  readonly title: string
  readonly children: React.ReactNode
}) {
  return (
    <section>
      <h2 className="mb-3 typo-body font-bold text-foreground">{title}</h2>
      <div className="space-y-2 typo-label text-muted-foreground">{children}</div>
    </section>
  )
}
